import isNil from 'lodash.isnil'

export type MyReimbursements = 'ALL' | 'MY_REIMBURSEMENTS' | 'MY_APPROVES'

export enum MyReimbursementsEnum {
  ALL = 'ALL',
  MY_REIMBURSEMENTS = 'MY_REIMBURSEMENTS',
  MY_APPROVES = 'COMPANY_REIMBURSEMENTS',
}

type PaginationOptions = {
  limit: number
  offset: number
  pageNumber: number
  pageSize: number
}

type SearchFilters = {
  categories: string
  status: string | string[]
  submittedDateFrom: string
  submittedDateTo: string
  endDate: string
  requesterName: string
  uuids?: string
  client_updated_at?: number
  myReimbursements?: MyReimbursements
  users: string
}

export type SearchQuery = PaginationOptions & Partial<SearchFilters>

type SearchKeys = keyof SearchQuery

export type SearchAction = {
  name: SearchKeys
  value: any
}

export const DEFAULT_SEARCH: SearchQuery = {
  limit: 50,
  offset: 0,
  pageNumber: 0,
  pageSize: 50,
  myReimbursements: MyReimbursementsEnum.ALL,
}

export const initialSearch = new URLSearchParams(
  DEFAULT_SEARCH as Record<string, any>,
).toString()

export function searchReducer(state: string, action: SearchAction): string {
  const next = new URLSearchParams(state)

  // reset
  if (!action.name || isNil(action.value)) return initialSearch

  // update
  if (action.value) next.set(action.name, action.value)
  else next.delete(action.name)

  return next.toString()
}

export const hasNonDefaultSearchParams = (
  queryParams: SearchQuery,
): boolean => {
  const defaultSearchKeys = Object.keys(DEFAULT_SEARCH)

  return Object.keys(queryParams).some(
    (key) => !defaultSearchKeys.includes(key),
  )
}
